import { Injectable } from '@angular/core';

import { lineChartOptions } from '../options/line-chart.options';
import { lineChartTimeOptions } from '../options/line-chart-time.options';
import { LineChartData } from '../models/line-chart.model';

import * as Chart from 'chart.js';
import * as _ from 'lodash';
import 'chartjs-plugin-datalabels';

@Injectable()
export class LineChartService {

  constructor() { }

  generateLineChart(chartCanvas: any, chartLabels: string[], datasets: LineChartData[], chartTypeOptions = 'default', displayLegend: boolean = true, legendPosition: string = 'top', beginAtZero: boolean = true) {
    const lineChartBaseOptions: any = chartTypeOptions === 'default' ? lineChartOptions : lineChartTimeOptions;

    // Disable fill.
    lineChartBaseOptions.elements.line.fill = false;

    // Check if the legend will be displayed.
    lineChartBaseOptions.legend.display = displayLegend;

    // Defines legend position.
    lineChartBaseOptions.legend.position = legendPosition;

    // Check if the yAxes values will start at zero.
    lineChartBaseOptions.scales.yAxes[0].ticks.beginAtZero = beginAtZero;

    this.generateChart(chartCanvas, chartLabels, datasets, lineChartBaseOptions);
  }

  generateAreaLineChart(chartCanvas: any, chartLabels: string[], datasets: LineChartData[], chartTypeOptions = 'default', displayLegend: boolean = true, legendPosition: string = 'top', beginAtZero: boolean = true) {
    const lineChartBaseOptions: any = chartTypeOptions === 'default' ? lineChartOptions : lineChartTimeOptions;

    // Enable fill.
    lineChartBaseOptions.elements.line.fill = true;

    // Check if the legend will be displayed.
    lineChartBaseOptions.legend.display = displayLegend;

    // Defines legend position.
    lineChartBaseOptions.legend.position = legendPosition;

    // Check if the yAxes values will start at zero.
    lineChartBaseOptions.scales.yAxes[0].ticks.beginAtZero = beginAtZero;

    this.generateChart(chartCanvas, chartLabels, datasets, lineChartBaseOptions);
  }

  private generateChart(chartCanvas: any, chartLabels: string[], datasets: LineChartData[], chartOptions: any) {
    // Add custom settings for datasets.
    datasets.forEach(d => {
      _.merge(d, {
        pointBackgroundColor : d.pointBackgroundColor || '#FFFFFF',
        pointHoverBackgroundColor : d.backgroundColor,
        pointHoverBorderColor : d.borderColor,
        pointHoverBorderWidth : 2
      });
    });

    const chart = new Chart(chartCanvas, {
      // The type of chart we want to create.
      type: 'line',

      // The data for our dataset
      data: {
        labels: chartLabels,
        datasets: datasets
      },

      // Configuration options go here
      options: chartOptions
    });
  }
}
